import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import {
  RequestUserDocumentResponse,
  UserDocumentCategory,
} from './types/UserDocument';

export default (makeCall: MakeCall) =>
  (
    userId: 'me' | number,
    data: {
      category: UserDocumentCategory;
    },
  ) =>
    makeCall<RequestUserDocumentResponse>(
      'POST',
      `/api/v2/user/${userId}/document/request`,
      {
        data,
      },
    );
